import React from 'react';
import { instituteMock } from '../data/mock';

const About = () => {
  const { about } = instituteMock;

  return (
    <section className="section-padding" id="about-section">
      <div className="container">
        <div className="grid-two-column">
          <div className="about-image">
            <img 
              src={about.image} 
              alt="Instituto Retina Viva" 
              loading="lazy"
            />
          </div>
          <div className="about-content">
            <h2 className="heading-1" style={{ marginBottom: '24px' }}>
              Sobre o Instituto
            </h2>
            <p className="body-large">
              {about.text}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
